import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import { useEffect } from 'react';
import { UserAuthorizationCard } from '@features/profile/user-authorization-card';
import { UserExitButton } from '@features/profile/ui/user-exit-button.tsx';
import { ActiveOrders } from '@features/order/active-orders';
import { ShortCuts } from '@features/profile/short-cuts';
import { BreadcrumbItem, Breadcrumbs } from '@heroui/react';
import { Home2 } from 'iconsax-react';
import { EditProfile } from '../../features/profile/edit-profile/edit-profile.tsx';

export const ProfilePage = () => {
  const set = useNavbar();

  useEffect(() => {
    set.profile();
  }, []);

  return (
    <>
      <div className="hidden lg:block container max-w-7xl mx-auto">
        <div className="hidden lg:block mt-12">
          <Breadcrumbs>
            <BreadcrumbItem href="/">
              <Home2 size="24" color="#9CA5AC" />
            </BreadcrumbItem>
            <BreadcrumbItem color="primary">Профиль</BreadcrumbItem>
          </Breadcrumbs>
        </div>

        <div className="mt-6">
          <h1 className="hidden lg:inline text-4xl text-[#222222] font-bold">
            Профиль
          </h1>
        </div>
      </div>

      <div className="hidden lg:flex flex-row container max-w-7xl mx-auto mt-12 pb-32 gap-x-12">
        <div className="w-[375px] flex flex-col">
          <UserAuthorizationCard />

          <ActiveOrders />

          <ShortCuts />

          <UserExitButton />
        </div>

        <div className="flex-grow max-w-[850px]">
          <EditProfile />
        </div>
      </div>

      <div className="pb-12 lg:hidden">
        <UserAuthorizationCard />

        <ActiveOrders />

        <ShortCuts />

        <UserExitButton />
      </div>
    </>
  );
};
